import { render, staticRenderFns } from "./order.vue?vue&type=template&id=5e51fd87&scoped=true&"
var script = {}
import style0 from "./order.vue?vue&type=style&index=0&id=5e51fd87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e51fd87",
  null
  
)

export default component.exports